module.exports = __webpack_public_path__ + "static/media/small_alexa.c16d4fc2.svg";